import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=22954e6e&scoped=true&"
var script = {}
import style0 from "./navigation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./navigation.vue?vue&type=style&index=1&id=22954e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22954e6e",
  null
  
)

export default component.exports